import React, { useState } from 'react';
import { updateUser } from '../traccar';
import { TagAlongWordmark } from '../TagAlongLogo';
import { useLang } from '../i18n';

const inp = { padding: '12px 14px', border: '1px solid #cbd5e1', borderRadius: '10px', fontSize: '15px', width: '100%', boxSizing: 'border-box', background: '#fff' };

// Shown the first time a phone-initiated customer signs in with the temporary
// password we issued. They must choose their own password before continuing;
// this also clears the mustSetPassword flag on their account.
export default function SetPasswordPage({ user, onDone }) {
  const [lang] = useLang();
  const es = lang === 'es';
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e && e.preventDefault();
    setErr('');
    if (pw.length < 6) { setErr(es ? 'La contraseña debe tener al menos 6 caracteres.' : 'Password must be at least 6 characters.'); return; }
    if (pw !== pw2) { setErr(es ? 'Las contraseñas no coinciden.' : 'Passwords do not match.'); return; }
    setBusy(true);
    try {
      const attrs = { ...(user.attributes || {}) };
      delete attrs.mustSetPassword;
      await updateUser({ ...user, password: pw, attributes: attrs });
      onDone && onDone();
    } catch (ex) {
      setErr(ex.message);
    } finally { setBusy(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'linear-gradient(160deg,#0a1a2f,#12325a)', padding: '20px' }}>
      <div style={{ width: 'min(400px, 96vw)', background: 'white', borderRadius: '18px', padding: '28px', boxShadow: '0 24px 60px rgba(0,0,0,0.4)' }}>
        <div style={{ textAlign: 'center', marginBottom: '6px' }}><TagAlongWordmark size={38} color="#12324a" pin="#f8703c" /></div>
        <div style={{ fontFamily: 'Poppins, sans-serif', fontWeight: 800, fontSize: '18px', color: '#0f172a', margin: '14px 0 4px' }}>{es ? 'Crea tu contraseña' : 'Create your password'}</div>
        <p style={{ fontSize: '13px', color: '#64748b', marginTop: 0 }}>{es ? 'Bienvenido' : 'Welcome'}{user && user.name ? `, ${String(user.name).split(' ')[0]}` : ''}. {es ? 'Elige una nueva contraseña para tu cuenta.' : 'Choose a new password to secure your account.'}</p>

        <form onSubmit={submit}>
          <label style={{ fontSize: '12px', fontWeight: 700, color: '#64748b' }}>{es ? 'Nueva contraseña' : 'New password'}</label>
          <div style={{ position: 'relative', margin: '5px 0 12px' }}>
            <input style={{ ...inp, paddingRight: '46px' }} type={show ? 'text' : 'password'} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="••••••••" autoFocus />
            <button type="button" onClick={() => setShow((s) => !s)} style={{ position: 'absolute', right: '6px', top: '50%', transform: 'translateY(-50%)', background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '18px', padding: '4px 8px' }}>{show ? '🙈' : '👁️'}</button>
          </div>
          <label style={{ fontSize: '12px', fontWeight: 700, color: '#64748b' }}>{es ? 'Confirmar contraseña' : 'Confirm password'}</label>
          <input style={{ ...inp, margin: '5px 0 12px' }} type={show ? 'text' : 'password'} value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder="••••••••" />

          {err && <div style={{ fontSize: '13px', color: '#dc2626', marginBottom: '10px', fontWeight: 600 }}>{err}</div>}

          <button type="submit" disabled={busy || !pw || !pw2}
            style={{ width: '100%', background: busy ? '#94a3b8' : 'linear-gradient(135deg,#0066ff,#0047d0)', color: 'white', fontWeight: 800, fontSize: '15px', border: 'none', borderRadius: '10px', padding: '13px', cursor: busy ? 'default' : 'pointer' }}>
            {busy ? (es ? 'Guardando…' : 'Saving…') : (es ? 'Guardar y continuar' : 'Save & continue')}
          </button>
        </form>
      </div>
    </div>
  );
}
